import turn from '../../../assets/abonar.webp'


const Abonar = ():JSX.Element => {
      return (
        <div className='flex flex-col bg-white w-4/5 rounded-t-xl mb-4'>
             
              <div>
              <img className='w-full h-60 rounded-t-xl' src={turn} />
              </div>
              
              <div className='ml-4 mt-2 mb-12 font-roboto font-medium'>
                <h1 className='sm:text-[28px] text-[20px] mb-1 '>ABONA LA CONSULTA</h1>
                <div>
                <p className='font-roboto text-[13px] sm:text-[20px] '>Podes abonar utilizando mercadopago, efectivo o mediante transferencia bancaria</p>
              </div>
              </div>
              
            
        </div>
      )
}


export default Abonar